import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import DocumentTitle from 'react-document-title'
import Controls from './Controls'
import Main from './Main'
import Additional from './Additional'
import {Spin} from 'antd'

import style from './style.sass'

@inject('store') @observer
class Builder extends Component {
  componentDidMount() {
    const {stockFilter} = this.props.store
    const {screenerID} = this.props.match.params
    if (screenerID) {
      stockFilter.single.load(screenerID)
    } else {
      stockFilter.single.blank()
    }
    this.checkPermission()
  }
  checkPermission = async () => {
    const {permissions} = this.props.store
    await permissions.loadSingle('lab.screener.create')
    const createDisabled = !permissions.check('lab.screener.create')
    if (createDisabled && !this.props.match.params.screenerID) {
      if (!window.location.pathname.endsWith('stock-filters/builder')) {
        return
      }
      permissions.showModal(
        false,
        'You have exceeded the max number of Algos included in your account. Please click here to upgrade'
      )
    }
  }
  render() {
    const {stockFilter} = this.props.store
    return(
      <div>
        <DocumentTitle title='Stock filter builder'/>

        <Spin size='large' spinning={stockFilter.single.loading}>
          <div className='card' styleName='top-card'>
            <Controls/>
            <Main/>
          </div>
          <Additional/>
        </Spin>
      </div>
    )
  }
}

export default Builder
